<form [formGroup]="filterForm"  id="formFilter" (ngSubmit)="onSubmit()">
  <mat-list-item  *ngFor="let item of filter.options; let i = index">
    <!-- <mat-checkbox color="accent" [checked]=" filter.selected ? filter.selected.id === item.id : i == 0" [value]=item
      (change)="selection = $event.checked">
      {{item.label | translate}}
    </mat-checkbox> -->
    <mat-radio-button cdkFocusInitial color="accent" [checked]=" filter.selected ? filter.selected.id === item.id : i == 0" [value]=item
      (change)="selection = $event.value">
      {{item.label | translate}}
    </mat-radio-button>
  </mat-list-item>
</form>
